// extracted by mini-css-extract-plugin
module.exports = {"alert":"AlertBox_alert__Y07SG","icon":"AlertBox_icon__1Dukk","error":"AlertBox_error__3G2vN","warning":"AlertBox_warning__x9dka","message":"AlertBox_message__2iuUX"};